var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46667 0C4.89347 0 2.8 2.09347 2.8 4.66667V6.53333H1.86667C0.8372 6.53333 0 7.37053 0 8.4V16.8C0 17.8295 0.8372 18.6667 1.86667 18.6667H13.0667C14.0961 18.6667 14.9333 17.8295 14.9333 16.8V8.4C14.9333 7.37053 14.0961 6.53333 13.0667 6.53333H12.1333V4.66667C12.1333 2.09347 10.0399 0 7.46667 0ZM4.66667 4.66667C4.66667 3.12293 5.92293 1.86667 7.46667 1.86667C9.0104 1.86667 10.2667 3.12293 10.2667 4.66667V6.53333H4.66667V4.66667ZM13.0685 16.8H8.4V14.6739C8.95533 14.35 9.33333 13.7545 9.33333 13.0667C9.33333 12.0372 8.49613 11.2 7.46667 11.2C6.4372 11.2 5.6 12.0372 5.6 13.0667C5.6 13.7536 5.978 14.35 6.53333 14.6739V16.8H1.86667V8.4H13.0667L13.0685 16.8Z",
    fill: "#06D6A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3d3734934efb90074f4b6a6c50e1b902.svg";
export { ForwardRef as ReactComponent };